import React from "react";

const EducatorMessage = () => {
  return (
    <div className="container mx-auto p-8">
      {/* Heading */}
      <h2 className="text-2xl font-bold text-gray-800 text-center mb-12">
        Director Message
      </h2>

      {/* Content Section */}
      <div className="flex flex-col md:flex-row items-center gap-12">
        {/* Photo Section */}
        <div className="w-full md:w-5/12">
          <img
            src="../../../../assets/seducator.JPG" // Replace with the actual image URL
            alt="Educator at Shree Krishna Academy"
            className="rounded-xl shadow-lg"
          />
        </div>

        {/* Text Section */}
        <div className="w-full md:w-7/12">
          <p className="text-lg text-gray-700 mb-8">
            As an educator, I see my role as guiding and nurturing the next
            generation to develop the skills needed for a life of health,
            prosperity, fulfillment, and respect.
          </p>
          <p className="text-lg text-gray-700 mb-8">
            At Shree Krishna Academy, we are committed to maintaining high
            standards and expectations for every student, ensuring their growth
            in academics, co-curricular activities, and overall development.
          </p>
          <p className="text-lg text-gray-700 mb-8">
            We embrace a holistic approach to education, employing innovative
            methods to foster both disciplinary and interdisciplinary
            understanding. Our efforts are rooted in the principles of
            psychology, sociology, and pedagogy, enabling us to create an
            environment that inspires academic excellence and personal growth.
          </p>
          <p className="text-lg text-gray-700 mb-8">
            Looking ahead, our curriculum will include the globally recognized
            Cambridge IGCSE program, providing students with an internationally
            benchmarked education that prepares them for success on a global
            stage.
          </p>
          <p className="text-lg text-gray-700">
            At Shree Krishna Academy, we remain dedicated to equipping our
            students with the tools and mindset to thrive in an ever-evolving
            world.
          </p>
          <div className="text-right mt-6">
            <p className="font-bold">Sudha Rani</p>
            <p>Director</p>
          </div>
        </div>
      </div>

      {/* Heading */}
      <h2 className="text-2xl font-bold text-gray-800 text-center mb-12 mt-12">
        Principal Message
      </h2>

      {/* Content Section */}
      <div className="flex flex-col md:flex-row items-center gap-12">
        {/* Photo Section */}
        <div className="w-full md:w-5/12">
          <img
            src="../../../../assets/principal.jpeg" // Replace with the actual image URL
            alt="Educator at Shree Krishna Academy"
            className="rounded-xl shadow-lg"
          />
        </div>

        {/* Text Section */}
        <div className="w-full md:w-7/12">
          <p className="text-lg text-gray-700 mb-8">
            At Shree Krishna Academy, we are dedicated to delivering exceptional
            education through a team of skilled and passionate educators. Our
            mission is to inspire learners to pursue knowledge with creativity
            and determination while fostering critical thinking, resilience, and
            innovation.
          </p>
          <p className="text-lg text-gray-700 mb-8">
            We emphasize academic excellence alongside values like integrity,
            empathy, and social responsibility, shaping students into
            compassionate, hardworking individuals ready to contribute
            meaningfully to society. Through a holistic approach, including
            co-curricular and extracurricular activities, we nurture
            well-rounded individuals equipped to seize opportunities and excel.
          </p>
          <p className="text-lg text-gray-700 mb-8">
            At the heart of our institution's philosophy lies the commitment to
            instill values such as integrity, empathy, and social
            responsibility. We strive to shape learners into individuals who are
            not only academically brilliant but also generous, hardworking, and
            compassionate. By nurturing these qualities, we prepare our students
            to become responsible citizens who play pivotal roles in their
            communities and contribute positively to the nation’s progress.
          </p>

          <p className="text-lg text-gray-700">
            As the Principal, I take immense pride in leading this institution
            where education goes beyond books to encompass life lessons and
            values that stand the test of time. I urge all learners to embrace
            challenges, stay curious, and remain dedicated to their goals. Let
            us together build a future where each student achieves greatness and
            contributes towards a better society and a brighter nation.
          </p>
          <div className="text-right mt-6">
            <p className="font-bold">R.K. Tiwary</p>
            <p>Principal</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EducatorMessage;
